import React,{useState} from 'react'
import register from '../img/register.png'
import receitaVazia from '../img/receita-img.svg'
import style from '../style/vazio.module.css'

export default function Vazio({item}){
    return(
        <div className={style.container}>
            {
                item === "Despesa" ? <img src={register} width={40}/> : <img src={receitaVazia} width={40}/>
            }
            <div className={style.content}>
                <p className={style.mensagem}>
                    Até o momento nenhum item  <br/> comece a registrar.
                </p>
            </div>
        </div>
    )
}